import { EASE_CALM } from "../../../lib/motion";

/** Matches the turn enter so the card grows with the incoming message. */
export const CHAT_BOX_GROW_S = 0.55;

export const CHAT_BOX_GROW_EASE = EASE_CALM;

export function chatBoxHeightKey(visibleIds: readonly string[], typingId: string | undefined): string {
	return `${visibleIds.join(",")}|${typingId ?? ""}`;
}

export function chatBoxHeightDurationS({
	animate,
	hasPriorMeasure,
}: {
	animate: boolean;
	hasPriorMeasure: boolean;
}): number {
	return animate && hasPriorMeasure ? CHAT_BOX_GROW_S : 0;
}

/** Opening size — question + reply, not the bills table. */
export const CHAT_BOX_MIN_HEIGHT_RATIO = 0.6;

export function chatBoxMinHeightPx(measuredCardHeight: number): number | undefined {
	if (measuredCardHeight <= 0) return undefined;
	return Math.round(measuredCardHeight * CHAT_BOX_MIN_HEIGHT_RATIO);
}
